module.exports = __webpack_public_path__ + "img/Asset2.8b08eb87.png";